import { IOptionFields } from '../questions/common/optionCard/Option';
import {
    Audience,
    AudienceRule,
    AudienceRuleOption,
    Panel,
    PanelType,
    QUOTA_STATUS,
    TENANT_LEVEL
} from '@nexxt/common/types';

export function getDefaultAudience(
    projectId: string,
    tenantLevel: TENANT_LEVEL
): Audience {
    return {
        projectId: +projectId,
        lengthOfInterview: null,
        totalSampleSize: null,
        panelType:
            tenantLevel === TENANT_LEVEL.SELF_SERVICE
                ? PanelType.INCA
                : PanelType.SELF_PROVIDED,
        panels: [defaultPanelSource],
        predefinedAudience: [],
        builtInAudienceRules: [],
        customAudienceRules: [],
        specialAudienceRules: [],
        deleteQuestionIDs: [],
        switchScreenerQuestionIDs: []
    };
}

export function getDefaultAudienceRule(): AudienceRule {
    return {
        selectedQuestion: null,
        audienceRuleOptions: [],
        edit: true,
        showCollapse: true
    };
}

// - TerminateEnabled boolean(checkmark) checked→ false
// - QuotaEnabled boolean(toggle) checked → true
export function getDefaultAudienceRuleOption(
    option: IOptionFields
): AudienceRuleOption {
    return {
        id: option.id,
        label: option.label,
        sampleSize: { min: 0, max: 0 },
        active: true,
        mode: {
            terminateEnabled: false,
            quotaEnabled: true
        }
    };
}

export function mapOptionToAudienceRuleOption(
    options: IOptionFields[]
): AudienceRuleOption[] {
    return options.map((option) => ({
        id: option.id,
        label: option.label,
        sampleSize: { min: 0, max: 0 },
        active: true,
        mode: {
            terminateEnabled: false,
            quotaEnabled: false
        }
    }));
}

export const defaultPanelSource: Panel = {
    name: 'General',
    key: '',
    advancedSettings: false,
    identifierKeys: [
        { identifierParamKey: 'psid', redirectIdentifierParamKey: '' }
    ],
    enableRedirect: false,
    redirectUrlSettings: {
        [QUOTA_STATUS.COMPLETE]: {
            type: QUOTA_STATUS.COMPLETE,
            url: '',
            includeParameters: true
        },
        [QUOTA_STATUS.TERMINATE]: {
            type: QUOTA_STATUS.TERMINATE,
            url: '',
            includeParameters: true
        },
        [QUOTA_STATUS.QUOTA_FULL]: {
            type: QUOTA_STATUS.QUOTA_FULL,
            url: '',
            includeParameters: true
        },
        [QUOTA_STATUS.SECURITY]: {
            type: QUOTA_STATUS.SECURITY,
            url: '',
            includeParameters: true
        }
    }
};

export const emptyPanelSource: Panel = {
    name: '',
    key: '',
    advancedSettings: false,
    identifierKeys: [
        { identifierParamKey: '', redirectIdentifierParamKey: '' }
    ],
    enableRedirect: false,
    redirectUrlSettings: {
        [QUOTA_STATUS.COMPLETE]: {
            type: QUOTA_STATUS.COMPLETE,
            url: '',
            includeParameters: true
        },
        [QUOTA_STATUS.TERMINATE]: {
            type: QUOTA_STATUS.TERMINATE,
            url: '',
            includeParameters: true
        },
        [QUOTA_STATUS.QUOTA_FULL]: {
            type: QUOTA_STATUS.QUOTA_FULL,
            url: '',
            includeParameters: true
        },
        [QUOTA_STATUS.SECURITY]: {
            type: QUOTA_STATUS.SECURITY,
            url: '',
            includeParameters: true
        }
    }
};
